import React from 'react';
import clsx from 'clsx';
import css from './Label.module.css';
import { TextBaseProps } from '../textBase/TextBase';

const Label: React.FC<TextBaseProps> = (props: TextBaseProps) => {
  return (
    <label className={clsx(css.textLabel, props.className)}>{props.text}</label>
  );
};

export default Label;
